import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-352">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-353"></div>

      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-354">
        <div className="flex items-center gap-1.5 text-2xl bg-white/5 px-4 py-2 rounded-full border border-white/10 shadow-inner" data-id="element-355">
          <span data-id="element-356">🇬🇧</span>
          <span data-id="element-357">🇦🇺</span>
          <span data-id="element-358">🇿🇦</span>
          <span data-id="element-359">🇳🇿</span>
        </div>
        <p className="text-text-sec text-sm sm:text-base font-medium" data-id="element-360">
          The No. 1 Rugby Union coaching resource trusted across the UK,
          Australia, South Africa &amp; New Zealand.
        </p>
      </div>
    </section>;
}